import React, { PropTypes } from 'react';
import classnames from 'classnames';
import NumberFormat from 'react-number-format';

import { daterange } from './Fields/DateRangePicker';
import { timerange } from './Fields/TimeRange';
import { selectStudent } from './Fields/SelectStudent';
import { selectClassStudent } from './Fields/SelectClassStudent';
import { selectClassTeacher } from './Fields/SelectClassTeacher';
import { selectTeacher } from './Fields/SelectTeacher';
import { selectClass } from './Fields/SelectClass';
import { selectClassroom } from './Fields/SelectClassroom';
import { datepicker } from './Fields/DatePicker';
import { selectDaysInWeek } from './Fields/SelectDaysInWeek';
import { selectDaysInMonth } from './Fields/SelectDaysInMonth';
import { reactselect } from './Fields/ReactSelect';
import { colorpicker } from './Fields/ColorPicker';
import { dropdownselect } from './Fields/DropdownSelect';
import { toggleswitch } from './Fields/ToggleSwitch';
import { textarea } from './Fields/Textarea';
import { timezone } from './Fields/TimeZone';
import { currency } from './Fields/Currency';
import { address } from './Fields/Address';
import { openhours } from './Fields/OpenHours';
import { agelimit } from './Fields/AgeLimit';
import { quantity } from './Fields/Quantity';
import { money } from './Fields/Money';
import { age } from './Fields/Age';
import { schoolhomepage } from './Fields/SchoolHomepage';
import { imageuploader } from './Fields/ImageUploader';

export default {
  selectDaysInWeek,  
  selectDaysInMonth,
  daterange,
  timerange,
  selectClassroom,  
  selectTeacher,
  selectStudent,
  selectClassStudent,
  selectClassStudent,
  selectClassTeacher,
  datepicker,  
  reactselect,
  colorpicker,
  dropdownselect,
  toggleswitch,
  imageuploader,
  textarea,
  timezone,
  currency,
  address,
  openhours,
  agelimit,
  money,
  quantity,
  age,
  schoolhomepage,
  component: (props)=>{
    const {
      options,
    } = props;
    if (options.component) {
      return options.component;
    } else {
      return <div/>;
    }
  },

}



// WEBPACK FOOTER //
// ./src/components/UI/Form/widgets.js